import { AbsenceStatus, AvailabilityDto, AvailabilityStatus } from 'api/model';

export const issueWarning = (a: AvailabilityDto): boolean => {
  return (
    a.bookedAssignments > 0 &&
    ((a.absenceStatus !== null && a.absenceStatus !== AbsenceStatus.DECLINED) ||
      a.scheduleStatus !== AvailabilityStatus.AVAILABLE)
  );
};

// How full is a value against its cap, as a 0–100 % (clamped)? Generic — the driving-policy progress
// bars use it for the week/month/28-day columns (each with its own max), and the overnight-stay warning
// in the assignment form uses it for the weekly cap. Shared so bars and warning never drift apart.
// `max` is required: each caller supplies its own cap (and its own fallback for a missing report value),
// so this stays domain-agnostic — no built-in weekly default that would be wrong for the 4-week columns.
export const getProgressWidthPercent = (value: number, max: number): number => {
  const clampedValue = Math.max(value || 0, 0);
  return clampedValue && max > 0 ? Math.min(100, (clampedValue / max) * 100) : 0;
};

// Timmarna som en körtidsstapel ska visa. Backend räknar in frånvaro (8h per frånvarodag) i
// HoursDrivenX, och den tiden ska fortsätta belasta körpolicyn — men för heltidsanställda ska
// den inte synas i stapeln alls, varken som en egen streckad sektion eller (ännu värre) som
// körtid. Därför dras den bort från både stapelns bredd och timtalet för dem. Backend lägger
// bara in frånvarotid för heltidsanställda, så för timanställda är det här en ren genomgång
// av totalen — men villkoret ligger på rätt ställe om den regeln breddas.
export const getDrivingBarHours = (
  totalHours: number | null | undefined,
  absenceHours: number | null | undefined,
  isFullTime: boolean | null | undefined
): number => {
  const total = Math.max(totalHours ?? 0, 0);
  if (!isFullTime) return total;
  return Math.max(total - Math.max(absenceHours ?? 0, 0), 0);
};

// Semantic level derived from a fill percentage, matching the progress-bar colours (getProgressColor):
// 'over' = at/over the cap (red), 'warning' = >70% (orange), 'good' = below (green).
export type ProgressLevel = 'good' | 'warning' | 'over';

export const getProgressLevel = (widthPercent: number): ProgressLevel => {
  if (widthPercent >= 100) return 'over';
  if (widthPercent > 70) return 'warning';
  return 'good';
};
